import React from "react";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useRecoilState, useRecoilValue } from "recoil";
import { resetRecoil } from "recoil-nexus";
import styled from "styled-components";
import { couponState, GenCouponType } from "../../recoil/coupon";
import { urlState } from "../../recoil/url";
import "../../styles/CustomModal.css";

const CouponModal = () => {
  const couponData = useRecoilValue<GenCouponType | null>(couponState);
  const [url, setUrl] = useRecoilState<string | null>(urlState);

  const onCloseModal = () => {
    resetRecoil(couponState);
  };

  const set_newLink = () => {
    if (url === null) {
      setUrl("coupon");
      onCloseModal();
    }
  };

  return (
    <Modal
      open={couponData !== null}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "optionCustomOverlay",
        modal: "couponModal",
      }}
      closeOnOverlayClick={false}
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        {couponData && (
          <div className="modal">
            <img
              className="closeIcon"
              onClick={onCloseModal}
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
              alt="close"
            />
            <h1>
              {couponData.type === 1 ? "신규입점 " : ""}
              {"쿠폰이\n발급 되었어요"}
            </h1>
            <div className="couponImgWrap">
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/coupon.svg`}
                alt="coupon"
              />
              <div className="couponTextWrap">
                <span>{couponData.price.toLocaleString()}원</span>
              </div>
              <p className="count">수량: {couponData.issue_limit_count}장</p>
            </div>

            <div>
              <h5>
                {"테스트 주문에 참여해 주셔서 감사합니다☺️\n감사의 마음으로 "}
                <span>{couponData.price.toLocaleString()}원</span>
                {"이 발급되었어요!"}
              </h5>
              <p>* 노크노크가 부담하는 우리매장 할인쿠폰입니다</p>
            </div>
            <div className="bottomButtonWrap">
              {/* <button className="confirmBtn" onClick={set_newLink}>
                쿠폰 확인하러 가기
              </button> */}
              <button className="cancelBtn" onClick={onCloseModal}>
                닫기
              </button>
            </div>
          </div>
        )}
      </Style>
    </Modal>
  );
};

export default CouponModal;

const Style = styled.div`
  @font-face {
    font-family: "여기어때 잘난체 고딕";
    src: url("${process.env.PUBLIC_URL}/font/JalnanGothicTTF.ttf")
      format("truetype");
  }

  .modal {
    width: 100%;
    text-align: center;
    padding: 40px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .closeIcon {
    position: absolute;
    top: 5%;
    right: 4%;
    cursor: pointer;
  }

  .couponImgWrap {
    width: min-content;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .couponTextWrap {
      position: absolute;
      width: 110px;
      top: 26px;
      left: 8px;
      text-align: center;
    }
    span {
      font-family: "여기어때 잘난체 고딕";
      font-size: 22px;
    }
  }

  h1 {
    font-size: 30px;
    line-height: 42px;
    font-weight: 400;
    font-family: "여기어때 잘난체 고딕";
    color: #4dd2ae;
  }

  h5 {
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    color: #333;
    span {
      font-weight: 700;
      color: #4dd2ae;
    }
  }
  p {
    font-size: 12px;
    line-height: 20px;
    color: #a7a7a7;
  }
  p.count {
    font-size: 10px;
    line-height: 10px;
    font-weight: 600;
    color: #979797;
  }

  .bottomButtonWrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;

    button {
      width: 90%;
      padding: 14px 0;
      font-size: 18px;
      border-radius: 10px;
      font-weight: 700;
      text-align: center;
      margin: 0 auto;
      cursor: pointer;
    }

    .confirmBtn {
      color: #ffffff;
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
    }
    .cancelBtn {
      color: #4dd2ae;
      background: #fff;
      border: 1px solid #4dd2ae;
    }
  }
`;
